var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDeeplink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.445 1.683a.45.45 0 0 1-.345.831A8.1 8.1 0 1 0 17.486 6.9a.45.45 0 0 1 .832-.344A9 9 0 0 1 10 19a9 9 0 0 1-9-9 9 9 0 0 1 12.445-8.317zm-3.604 5.93a.45.45 0 0 1 0-.637l1.751-1.75a1.346 1.346 0 0 1 1.908 0L14.773 6.5a1.347 1.347 0 0 1 .002 1.907l-3.186 3.185a1.344 1.344 0 0 1-1.907 0l-.637-.638a.449.449 0 0 1 .49-.734.45.45 0 0 1 .146.098l.638.637a.446.446 0 0 0 .634.001l3.185-3.185a.447.447 0 0 0 0-.634l-1.275-1.274a.446.446 0 0 0-.635 0l-1.75 1.75a.45.45 0 0 1-.637 0zm.318 4.773a.449.449 0 0 1 0 .638l-1.751 1.75a1.346 1.346 0 0 1-1.908 0L5.227 13.5a1.349 1.349 0 0 1-.002-1.908l3.186-3.185a1.346 1.346 0 0 1 1.907.001l.637.638a.448.448 0 0 1-.146.734.45.45 0 0 1-.49-.098l-.638-.637a.446.446 0 0 0-.634-.001l-3.185 3.185a.448.448 0 0 0 0 .634l1.275 1.274a.446.446 0 0 0 .635 0l1.75-1.75a.449.449 0 0 1 .637 0z",
    fill: "#1C2154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeeplink);
export default __webpack_public_path__ + "static/media/icon-deeplink.a4b2be76.svg";
export { ForwardRef as ReactComponent };